import { render, staticRenderFns } from "./BoatNew.vue?vue&type=template&id=33755008&"
import script from "./BoatNew.vue?vue&type=script&lang=js&"
export * from "./BoatNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports